export enum ActionType {
    TC__CM__NAVIGATE = 'TC__CM__NAVIGATE',
    TC__CM__MIN_MAX = 'TC__CM__MIN_MAX',
}
